import {
  Environment
} from '@vodacom/web-env';

import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  CacheKeys,
  JavascriptTypes
} from '../../../constants';

import {
  AppState,
  getAuthToken,
  getStorageWithExpiry,
  isValidEncMsisdn,
  mapEligibility,
  mapRewardHistory,
  onVouchersNoAuth
} from 'helpers';

export class AdvanceProvider {

  static BASE_URL = Environment.current.advancesHost + Environment.current.advancesBase;
  static STATE = AppState.with('AdvanceProvider');
  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  static getMsisdn() {
    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async getAvailableOffers() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}offers`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.AirtimeAdvanceOffers
      }
    )
    .then((res) => {
      if (!res.result) {

        return {
          ok: false,
          error: new Error('Advances offers verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }
      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }

  static async getAdvanceHistory() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}history`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.AirtimeAdvanceHistory
      }
    )
    .then((res) => {

      if (!res?.result) {

        return {
          ok: false,
          error: new Error('Advances history verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getBalances() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}balances`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.AirtimeAdvanceBalances
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Advances balances verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getSimSwapEligibility() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}simswap/processed`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.AirtimeAdvanceEligibility
      }
    )
    .then((res) => {

      if (!res?.result) {

        return {
          ok: false,
          error: new Error('sim swap process eligibility error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async provisionLoan(
    type,
    bandId
  ) {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}loan`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn(),
          'type': type,
          'bandId': bandId
        }
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Provision loan error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getEligibility() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}products/vouchers`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken(),
          'x-api-channel': 'CONNECTU'
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.VoucherAdvanceEligibility,
        mapper: mapEligibility
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Advances eligibility verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      if (error.response?.status === 400) {

        AdvanceProvider.STATE.setItem(CacheKeys.VoucherAdvanceEligibility, error.response);
      }

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getOpenLoans() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}products/vouchers/loans`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.VoucherAdvanceOpenLoans
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Vouchers open loans verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getRewardHistory() {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}reward/history`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: CacheKeys.VoucherAdvanceRewardHistory,
        mapper: mapRewardHistory
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Vouchers reward history verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getRedemptionHistory(rewardId) {

    if (!isValidEncMsisdn(AdvanceProvider.getMsisdn())) {

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return AdvanceProvider.STATE.makeServiceCall(
      `${AdvanceProvider.BASE_URL}reward/gift-card/${rewardId}/history`,
      {
        method: 'POST',
        headers: {
          ...AdvanceProvider.DEFAULT_HEADERS,
          'Authorization': 'Bearer ' + getAuthToken()
        },
        bodyParams: {
          'id': AdvanceProvider.getMsisdn()
        },
        cacheKey: `${CacheKeys.VoucherAdvanceRedemptionHistory}-${rewardId}`
      }
    )
    .then((res) => {

      if (!res.result) {

        return {
          ok: false,
          error: new Error('Vouchers reward history verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = AdvanceProvider.STATE.getItem(key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      AdvanceProvider.trackVolatileCache(key);

      return response;
    }

    return cachedItem;
  }

  static trackVolatileCache(key) {
    const volatileCache = JourneyProvider.get(CacheKeys.Volatile, 'AdvanceProvider') || [];
    JourneyProvider.set(CacheKeys.Volatile, { AdvanceProvider: [ ...volatileCache, key ] });
  }

  static purgeVolatileCache() {
    const volatileCache = JourneyProvider.get(CacheKeys.Volatile, 'AdvanceProvider');
    for (let i = 0; i < volatileCache.length; i ++) {
      const key = volatileCache[i];
      AdvanceProvider.deleteCachedItem(key);
    }
    JourneyProvider.set(CacheKeys.Volatile, { AdvanceProvider: [] });
  }

  static deleteCachedItem(key) {
    AdvanceProvider.STATE.removeItem(key);
  }
};
